import { isCompanyUser, useLoginContext } from "@bindeleddet/core/contexts/login";
import { EventRegistrationStatus } from "@bindeleddet/core/types";
import { COLORS_PER_STATUS, LABELS_PER_STATUS } from "./constants";
import { StatusBadge } from "./style";

interface Props {
  status: EventRegistrationStatus | null | undefined;
}

const EventStatusBadge: React.FC<Props> = ({ status }) => {
  const { currentUser } = useLoginContext();
  if (!currentUser?.id || isCompanyUser(currentUser)) return null;
  // Put a non-breaking space in the badge if the event status is not yet loaded so that it is displayed correctly
  // eslint-disable-next-line no-irregular-whitespace
  if (!status) return <StatusBadge color="#fff"> </StatusBadge>;
  return <StatusBadge color={COLORS_PER_STATUS[status]}>{LABELS_PER_STATUS[status]}</StatusBadge>;
};

export default EventStatusBadge;
